module.exports = __webpack_public_path__ + "img/model_51_ug.9bee9f6f.jpg";